<route lang="json">
{
  "name": "gallery-index"
}
</route>

<script setup lang="ts">
import { MaterialQueryValues } from "@/composables/useMaterialQueriesNew";

const props = defineProps<{ params: MaterialQueryValues }>();

const params = computed(() => {
  return { ...props.params, provider: "fobizz" };
});
</script>

<template>
  <GalleryResultList :params="params" />
</template>
